// 用gettter取数据到组件里,是数据的映射

export default {

}
